<template>
  <div>
    <!-- 배경 이미지 -->
    <img :src="backgroundImage" alt="Background Image" class="background-image" />

    <!-- 로그인 폼 -->
    <div class="login-container">
      <!-- 좌상단 언어 토글 (로그인 화면에서도 노출) -->
      <div class="login-lang-toggle" role="group" :aria-label="$t('lang.ko') + ' / ' + $t('lang.en')">
        <button type="button" class="lang-btn" :class="{ active: $i18n.locale === 'ko' }" @click="switchLang('ko')">KO</button>
        <button type="button" class="lang-btn" :class="{ active: $i18n.locale === 'en' }" @click="switchLang('en')">EN</button>
      </div>
      <h1>{{ $t('login.title') }}</h1>
      <form @submit.prevent="login">
        <div>
          <label for="email">{{ $t('login.emailLabel') }}</label>
          <input type="text" v-model="email" :placeholder="$t('login.emailPlaceholder')" required />
        </div>
        <div>
          <label for="password">{{ $t('login.passwordLabel') }}</label>
          <input type="password" v-model="password" :placeholder="$t('login.passwordPlaceholder')" required />
        </div>
        <div class="button-container">
          <button type="submit">{{ $t('login.loginButton') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { refreshTenant } from '@/tenant';

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      backgroundImage: require('@/assets/Trace Tag Tracker management system.png'),
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post('/api/login', {
          email: this.email,
          password: this.password,
        });

        console.log('서버 응답:', response.data);  // 기존 로그
        console.log('Company from response:', response.data.user.company); // 추가

        if (response.data.success) {
          // 토큰을 로컬 스토리지에 저장
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('company', response.data.user.company);
          localStorage.setItem('isadmin', response.data.user.isadmin);
          localStorage.setItem('email', response.data.user.email || this.email);
          
          // localStorage 저장 후 확인 로그
          console.log('Stored company in localStorage:', localStorage.getItem('company'));
          
          // 최초 로그인(초기 비밀번호) 계정은 비밀번호 변경 화면으로 보낸다
          if (response.data.mustChangePassword) {
            localStorage.setItem('mustChangePassword', '1');
            this.$router.push('/change-password');
            return;
          }
          localStorage.removeItem('mustChangePassword');

          // 회사별 첫 화면·기본 언어는 테넌트 프리셋(packages/tenant-config)이 정한다
          const tenant = refreshTenant();
          if (tenant.lang) {
            try { localStorage.setItem('lang', tenant.lang); this.$i18n.locale = tenant.lang; } catch (e) { /* ignore */ }
          }
          this.$router.push(tenant.homeRoute || '/dashboard');
          
          // 라우팅 후 company 값 재확인
          console.log('Company after routing:', localStorage.getItem('company'));
          
          await this.checkActiveStatus();
          await this.checkGatewayActiveStatus();
        } else {
          alert(this.$t('login.alertFail', { msg: response.data.message }));
        }
      } catch (error) {
        console.error('로그인 요청 실패:', error);
        alert(this.$t('login.alertIdPwMismatch'));
      }
    },
    switchLang(lang) {
      if (lang !== 'ko' && lang !== 'en') return;
      this.$i18n.locale = lang;
      try { localStorage.setItem('lang', lang); } catch (e) { /* ignore */ }
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', lang);
      }
    },

    async checkActiveStatus() {
      try {
        const response = await axios.post('/api/checkactive/tag');
        console.log('tag checkactive 응답:', response.data);
      } catch (error) {
        console.error('tag checkactive 호출 실패:', error);
      }
    },
    async checkGatewayActiveStatus() {
      try{
        const response = await axios.post('/api/checkactive/gateway');
        console.log('Gateway Active 상태가 업데이트되었습니다:', response.data);
      } catch (error) {
        console.error('Failed to check active status:', error);
      }
    },
  },
};
</script>

<style scoped>
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-container {
  position: relative;
  max-width: 600px;
  max-height: 300px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: rgba(240, 241, 239, 0.5);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 300px;
}

label {
  display: block;
  margin-bottom: 8px;
}

input {
  width: calc(100% - 20px);
  padding: 8px;
  margin-right: 20px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.button-container {
  text-align: right;
}

button {
  width: 20%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: rgb(0, 55, 173);
}

/* 로그인 화면 우상단 언어 토글 */
.login-lang-toggle {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  border: 1px solid #d0d7de;
  border-radius: 999px;
  overflow: hidden;
  background: #ffffff;
}
.login-lang-toggle .lang-btn {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #586069;
  cursor: pointer;
  width: auto;
  border-radius: 0;
}
.login-lang-toggle .lang-btn + .lang-btn { border-left: 1px solid #d0d7de; }
.login-lang-toggle .lang-btn:hover { background: #f3f4f6; color: #24292f; }
.login-lang-toggle .lang-btn.active { background: #1f4e79; color: #ffffff; }
</style>
